<template>
    <div>
        {{message}} <br /> 
        <a data-togle="modal" :data-target="'#'+createModalId" v-if="createButton" type="button" class="btn btn-link">
            <i class="fa fa-plus"></i> Agregar
        </a>
    </div>
</template>

<script>
export default {
    name: 'NoOptionResults',
    props: {
        message: {
            type: String,
            required: true
        },
        createButton: {
            type: Boolean,
            default: false
        },
        createModalId: {
            type: String,
            required: false
        } 
    }
}
</script>